import Vue from 'vue'
import Router from 'vue-router'
import Home from 'LocalComponents/Home.vue'
import Scan from 'LocalComponents/Scan.vue'
import NotFound from 'Core/src/views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,

  mode: 'history',

  routes: [
    {
      path: '/index.html',
      component: Home
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/scan',
      component: Scan
    }
  ]
})

export default router
